import { Component } from '@angular/core';

@Component({
  selector: 'app-mapping-manager',
  templateUrl: './mapping-manager.component.html',
  styleUrls: ['./mapping-manager.component.css']
})
export class MappingManagerComponent {

}
